type ProjectForVersionResolve =
  | {
      files?: {
        fileId: string;
        currentVersion?: number;
        versions?: {
          versionId: string;
          versionNumber: number;
          reviewTicketId?: string | null;
        }[];
      }[];
    }
  | null
  | undefined;

/**
 * Map a reviews-panel row (fileId + versionNumber) onto the project's
 * file-version `versionId` used by the approval-events API.
 */
export function resolveReviewVersionId(
  project: ProjectForVersionResolve,
  review:
    | { fileId?: string | null; versionNumber?: number | null }
    | null
    | undefined,
): string | null {
  if (
    !project?.files?.length ||
    !review?.fileId ||
    review.versionNumber == null
  ) {
    return null;
  }
  const file = project.files.find((f) => f.fileId === review.fileId);
  if (!file?.versions?.length) return null;
  const version = file.versions.find(
    (v) => v.versionNumber === review.versionNumber,
  );
  return version?.versionId ?? null;
}

/**
 * Fallback when Reviews has no active row: latest version on the first file
 * that has version history. Lets the Participation panel show on projects
 * that have assets even before a review ticket exists.
 */
export function resolveLatestProjectVersionTarget(
  project: ProjectForVersionResolve,
): {
  fileId: string;
  versionId: string;
  ticketId: string | null;
} | null {
  for (const file of project?.files ?? []) {
    const versions = file.versions ?? [];
    if (!versions.length) continue;
    const latest =
      (file.currentVersion != null
        ? versions.find((v) => v.versionNumber === file.currentVersion)
        : null) ??
      [...versions].sort((a, b) => b.versionNumber - a.versionNumber)[0];
    if (!latest?.versionId) continue;
    return {
      fileId: file.fileId,
      versionId: latest.versionId,
      ticketId: latest.reviewTicketId ?? null,
    };
  }
  return null;
}
